import React from "react";
import { SourceType } from "../../API/courseware";
import { atomFamily } from "jotai/utils";
import { atom } from "jotai";
import { getCourseList } from "../../API";

interface ChapterContextProps {
    resourceList: SourceType[];
    todoResource?: SourceType;
    onViewCourseware: (id: string) => void;
    onContinue: () => void;
}

export const ChapterContext = React.createContext<ChapterContextProps>({
    resourceList: [],
    onViewCourseware: () => null,
    onContinue: () => null
});

export const CourseListAtom = atomFamily(
    ({ courseNo, courseSeq }: { courseNo: string; courseSeq: string }) => {
        return atom(get => {
            return getCourseList(undefined, courseNo, courseSeq);
        });
    },
    (arg1, arg2) => {
        return (
            arg1.courseNo === arg2.courseNo && arg1.courseSeq === arg2.courseSeq
        );
    }
);
